import React from 'react';
import Layout from '../../../../components/Layout';
import ServicesLayout from '../../../../components/ServicesLayout';
import AddDistrict from './AddDistrict';
import StepClass from '../../../../classes/StepClass';
import stepperWrapper from '../../../../hocs/stepperWrapper';
import layoutWrapper from '../../../../hocs/layoutWrapper';
import fetch from '../../../../core/fetch';

import { isAdminUser } from '../../../../lib/utils';


const title = 'Dodawanie urzędu';

export default {
  path: '/addDistrict',
  async action(ctx) {
    const isAdmin = await isAdminUser(ctx);
    if (!isAdmin) {
      return { redirect: '/' };
    }

    const fetchPrefixes = `${process.env.API_URL}/prefixes`;
    const prefixes = await fetch(fetchPrefixes).then(r => r.json());

    const component = stepperWrapper(<AddDistrict title={title} {...prefixes} />, [
      new StepClass('/admin', 'Admin'),
      new StepClass('/districts', 'Gminy'),
      new StepClass('/addDistrict', 'Dodaj urząd'),
    ]);

    return {
      title,
      chunk: 'addDistrict',
      component: layoutWrapper({ prefixes, isAdmin }, component),
    };
  },
};



// WEBPACK FOOTER //
// src/routes/admin/districts/add_district/index.js